<template>
 <div id="login">
   <img src="/static/img/system128.png" class="center-block logo">
   <div class="text-center col-sm-12">
     <!-- login form -->
     <form @submit.prevent="signIn">
       <div class="input-group">
         <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
         <input class="form-control" name="email" placeholder="Digite seu email" type="text" v-model="email">
       </div>

       <div class="input-group">
         <span class="input-group-addon"><i class="fa fa-lock"></i></span>
         <input class="form-control" name="password" placeholder="Digite sua senha" type="password" v-model="password">
       </div>
       <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">Entrar</button>
     </form>
    
     <!-- errors -->
     <div v-if=response class="text-red"><p class="vertical-5p lead">{{response}}</p></div>
   </div>
 </div>
</template>

<script>
import {firebaseApp} from '../helpers/firebaseApp'

var db = firebaseApp.database()
var usuario = {}
export default {
  name: 'Login',
  data(router) {
    return {
      section: 'Login',
      loading: '',
      email: '',
      password: '',
      response: ''
    }
  },
  methods: {
    track () {
      this.$ga.page('/login')
    },
    switchLang(lang) {
      this.$store.commit('SET_LANG', lang)
    },
    signIn: function() {
      this.toggleLoading()
      firebaseApp.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (resposta) => {
          this.toggleLoading()
          // this.$store.commit('SET_USER', resposta.user)
          this.$store.commit('SET_TOKEN', resposta.user.refreshToken)
          // window.localStorage.setItem('token', resposta.user.refreshToken)
          this.$store.commit('SET_USER', firebaseApp.auth().currentUser)
          var uid = firebaseApp.auth().currentUser.uid
          var Users = db.ref('Users/' + uid)
          Users.on('value', function(snapshot) {
            usuario = snapshot.val()
            this.switchLang(usuario.flag)
          }, function (errorObject) { console.log('The read failed: ' + errorObject.code) })
          // window.localStorage.setItem('user', JSON.stringify(firebaseApp.auth().currentUser))
          this.$router.push('/')
        },
        (err) => {
          this.$store.commit('TOGGLE_LOADING')
          this.toggleLoading()
          alert(err.message)
        }
      )
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
    }
  }
}
</script>

<style>
#login {
  padding: 1em;
}

html,
body,
.container-table {
  height: 100%;
  background-color: #282b30 !important;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.vertical-5p {
  padding-top: 5%;
}
.logo {
  width: 15em;
  padding: 3em;
}

.input-group {
  padding-bottom: 2em;
  height: 4em;
  width: 100%;
}

.input-group span.input-group-addon {
  width: 2em;
  height: 4em;
}

@media (max-width: 1241px) {
  .input-group input {
    height: 4em;
  }
}
@media (min-width: 1242px) {
  form {
    padding-left: 20em;
    padding-right: 20em;
  }

  .input-group input {
    height: 6em;
  }
}

.input-group-addon i {
  height: 15px;
  width: 15px;
}
</style>



// WEBPACK FOOTER //
// Login.vue?503acfba